export default __webpack_public_path__ + "static/IDA_Quick_Hits_Thumb-9536a299d28faf6079476e2eb7f08d1b.jpg";